export default __webpack_public_path__ + "static/media/discord_black.8f79e629.svg";